export default "__VITE_ASSET__CS6H1tQV__"